import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import PassportFactory from './PassportFactoryField.js';


class PassportContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      passport: this.props.passport,
      isEditing: true
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ passport: props.passport });
  }

  handleChange = (event) => {
    var element = this.state.passport.find(f => f.id === event.target.id);
    element.value = event.target.value;
    var foundIndex = this.state.passport.findIndex(x => x.id == event.target.id);
    var newPassport = this.state.passport;
    newPassport[foundIndex] = element;
    this.setState({ passport: newPassport });
  }

  handleRadioChange = (event) => {
    var radioElement = this.state.passport.find(f => f.id === event.target.name);
    radioElement.value = event.target.value;
    var foundIndex = this.state.passport.findIndex(x => x.id == event.target.name);
    var newPassport = this.state.passport;
    newPassport[foundIndex] = radioElement;
    this.setState({ passport: newPassport });
  }

  componentDidMount() {
    $("[id*='_date']").datepicker();
  }

  renderPassportField = (field, holder) => {
    return (
      <PassportFactory
        field={field}
        t={this.props}
        disabled={!this.state.isEditing}
        holder={holder}
        handleChange={this.handleChange}
        handleRadioChange={this.handleRadioChange} />
    );
  }

  handleCancelClick = () => {
    this.setState({ isEditing: false });
    this.props.handleCancelClick();
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  }

  handlePassportSubmit = (event) => {
    this.setState({ isEditing: false });
    this.props.handlePassportSubmit(event);
  }


  render() {
    const isEditing = this.state.isEditing;
    const { t } = this.props;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default">
            <div className="panel-body">
              <h4 className="ioscentro">{t('dashboard.profile.passport.heading')}</h4>
              <form method="post" onSubmit={this.handlePassportSubmit} >
                <fieldset>
                  <div className="row">

                    {/*}
                    <div className="col-lg-6">                    
                      <div className="form-group">
                        <label htmlFor="name">
                          {t('dashboard.profile.passport.label_card')}
                        </label>
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'no_tarjeta'),t('dashboard.profile.passport.holder_card'))}
                      </div>
                    </div>
                     {*/}

                    <div className="col-lg-4">
                      <div className="form-group">
                        {/* <label htmlFor="interests">
                          {t('dashboard.profile.passport.label_emergency_contact')}
                        </label> */}
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_name'), t('dashboard.profile.passport.holder_emergency_contact'))}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="emergency_relation">
                          {t('dashboard.profile.passport.label_emergency_contact_rel')}
                        </label>
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_relation'), t('dashboard.profile.passport.label_emergency_contact_rel'))}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        {/* <label htmlFor="emergency_email">
                          {t('dashboard.profile.passport.label_emergency_contact_email')}
                        </label> */}
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_email'), t('dashboard.profile.passport.holder_emergency_contact_email'))}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        {/* <label htmlFor="interests">
                          {t('dashboard.profile.passport.label_emergency_contact_phone')}
                        </label> */}
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_phone'), t('dashboard.profile.passport.holder_emergency_contact_phone'))}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        {/* <label htmlFor="interests">
                          {t('dashboard.profile.passport.label_emergency_contact_blood')}
                        </label> */}
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_blood'), t('dashboard.profile.passport.holder_emergency_contact_blood'))}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        {/* <label htmlFor="interests">
                          {t('dashboard.profile.passport.label_emergency_contact_alergies')}
                        </label> */}
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'emergency_alergies'), t('dashboard.profile.passport.holder_emergency_contact_alergies'))}
                      </div>
                    </div>




                    {/*}
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="email">
                        {t('dashboard.profile.passport.label_gender')}
                        </label>
                        {this.renderPassportField(this.state.passport.find(f => f.id === 'genero'),null)}
                      </div>
                    </div>
                    {*/}

                  </div>

                  <div className="form-group">
                    <button
                      className="btn btn-link"
                      data-target="#morePassportFields"
                      data-toggle="collapse"
                      type="button">
                      {t('dashboard.profile.btn_more')}&nbsp;
                      <span className="caret" />
                    </button>
                  </div>
                  <div className="collapse" id="morePassportFields">
                    <div className="row">

                      {/*}
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="gender">
                          {t('dashboard.profile.passport.label_email')}
                          </label>
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'correo'),t('dashboard.profile.passport.holder_email'))}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="birthdate">
                          {t('dashboard.profile.passport.label_phone')}
                          </label>
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'telefono'),t('dashboard.profile.passport.holder_phone'))}
                        </div>
                      </div>
                      {*/}

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="contactEmail">
                            {t('dashboard.profile.passport.label_boss')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'jefe'), t('dashboard.profile.passport.holder_boss'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="phone">
                            {t('dashboard.profile.passport.label_assistant')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'asistente'), t('dashboard.profile.passport.holder_assistant'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="position">
                            {t('dashboard.profile.passport.label_employees')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'empleados'), t('dashboard.profile.passport.holder_employees'))}
                        </div>
                      </div>


                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="lastname">
                            {t('dashboard.profile.passport.label_clasification')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'clasificacion'), t('dashboard.profile.passport.holder_clasification'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="estado_civil">
                            {t('dashboard.profile.passport.label_maritalstatus')}
                          </label>
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'estado_civil'), null)}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_aniversary')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'anniversary_date'), t('dashboard.profile.passport.holder_aniversary'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_so')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'so'), t('dashboard.profile.passport.holder_so'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_so_birthday')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'so_birthday_date'), t('dashboard.profile.passport.holder_so_birthday'))}
                        </div>
                      </div>

                      <div className="col-lg-4" style={{minHeight: '84.41px'}}>
                        <div className="form-group">
                          <label htmlFor="hijos">
                            {t('dashboard.profile.passport.label_children')}
                          </label>
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'hijos'), t('dashboard.profile.passport.holder_children'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_so_email')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'so_email'), t('dashboard.profile.passport.holder_so_email'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_so_phone')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'so_phone'), t('dashboard.profile.passport.holder_so_email'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="food">
                            {t('dashboard.profile.passport.label_food')}
                          </label>
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'food'), null)}
                        </div>
                      </div>

                      {/* fase 2  */}


                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_drink')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'drink'), t('dashboard.profile.passport.holder_drink'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_restaurant')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'restaurant'), t('dashboard.profile.passport.holder_restaurant'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_sport')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'sport'), t('dashboard.profile.passport.holder_sport'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_culture')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'culture'), t('dashboard.profile.passport.holder_culture'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_hobbies')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'hobby'), t('dashboard.profile.passport.holder_hobbies'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_scent')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'scent'), t('dashboard.profile.passport.holder_scent'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_color')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'color'), t('dashboard.profile.passport.holder_color'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_accesories')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'accesory'), t('dashboard.profile.passport.holder_accesories'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_artist')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'artist'), t('dashboard.profile.passport.holder_artist'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_music')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'music'), t('dashboard.profile.passport.holder_music'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_coffee')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'coffee'), t('dashboard.profile.passport.holder_coffeee'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_traveling')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'traveling'), t('dashboard.profile.passport.holder_traveling'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_pendings')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === '2things'), t('dashboard.profile.passport.holder_pendings'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_job')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'job'), t('dashboard.profile.passport.holder_job'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_schedule')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'job_schedule'), t('dashboard.profile.passport.holder_schedule'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_car')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'car_model'), t('dashboard.profile.passport.holder_car'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_car_color')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'car_color'), t('dashboard.profile.passport.holder_car_color'))}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          {/* <label htmlFor="interests">
                            {t('dashboard.profile.passport.label_car_plates')}
                          </label> */}
                          {this.renderPassportField(this.state.passport.find(f => f.id === 'car_plates'), t('dashboard.profile.passport.holder_car_plates'))}
                        </div>
                      </div>


                    </div>
                  </div>

                  <section className={isEditing ? "content-buttons" : "hidden"}>
                    <button
                      className="btn btn-full-width btn-primary"
                      type="submit">
                      {t('dashboard.profile.btn_save')}
                    </button>
                    <button
                      className="btn btn-full-width btn-default"
                      onClick={this.handleCancelClick}
                      type="button">
                      {t('dashboard.profile.btn_cancel')}
                    </button>
                  </section>
                  <button
                    className={!isEditing ? "btn btn-full-width btn-primary" : "hidden"}
                    onClick={this.handleEditClick}
                    type="button">
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    &nbsp; {t('dashboard.profile.btn_edit')}
                  </button>

                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(PassportContainer);



// WEBPACK FOOTER //
// ./src/dashboard/profile/PassportContainer.js